var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "errors-quote", attrs: { role: "presentation" } },
    [
      _c("div", { staticClass: "columns is-12" }, [
        _c(
          "div",
          { staticClass: "column is-6 message-panel" },
          [
            _vm.quote
              ? _c("p", {
                  staticClass: "quote",
                  attrs: { "aria-hidden": "true" },
                  domProps: { innerHTML: _vm._s(_vm.quote.html) },
                })
              : _vm._e(),
            _vm._t("message-panel"),
          ],
          2
        ),
        _vm.quote
          ? _c("div", {
              staticClass: "column is-6 image-panel",
              style: _vm.imageStyle,
              attrs: { "aria-hidden": "true" },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }